<template>
  <b-input-group>
    <cleave
      id="custom_variable_value"
      v-model="realdate"
      class="form-control"
      :raw="false"
      :options="options.date"
      placeholder="DD-MM-YYYY"
      data-id="datepicker"
      data-fieldtype="input"
    />
    <b-input-group-append
      id="custom_variable_value"
    >
      <b-form-datepicker
        v-model="formattedDate"
        :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
        :class="`form-group`"
        trim
        button-only
        right
        size="sm"
        data-id="datepicker"
        data-fieldtype="input"
      />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
// import { ValidationProvider/* , ValidationObserver */ } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import {
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
} from 'bootstrap-vue'

export default {
  components: {
    Cleave,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
  },
  props: {
    selectModel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formattedDate: '',
      realdate: '2024-12-13',
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
    }
  },
  watch: {
  },
  created() {
    console.log('date is date type ', this.selectModel)
    this.formatDate()
  },
  methods: {
    formatDate() {
      const [year, month, day] = this.selectModel.split('-')
      this.formattedDate = `${day}-${month}-${year}`
      console.log('formated is ', this.formattedDate)
    },
  },
}
</script>

          <style lang="scss">
          </style>
